import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { CometChatModal } from 'components/base/Modal'
import { CometChatButton } from 'components/base/Button'
import { RootState } from 'redux/types'
import style from './style.module.scss'

const MODAL_ID = 'importUserRequest'

const IMPORT_OPTIONS: Array<{ label: string; value: string }> = [
  { label: 'A database', value: 'database' },
  { label: 'A CSV file', value: 'csv-file' },
  { label: 'Another Chat Provider', value: 'another-chat-provider' },
]

/**
 * Global "Import users" support-intent modal — triggered externally (e.g. a
 * Zendesk chat flow dispatching `users/SHOW_IMPORT_USER_REQUEST`), which sets
 * `settings.visibleModalID` to `importUserRequest`. Rendered once in
 * `layouts/Main` alongside the other global modals.
 */
const ImportUsersModal: React.FC = () => {
  const dispatch = useDispatch()
  const visibleModalID = useSelector((state: RootState) => state.settings.visibleModalID)
  const visible = visibleModalID === MODAL_ID

  const handleCancel = () => {
    dispatch({ type: 'settings/CHANGE_SETTING', payload: { setting: 'visibleModalID', value: '' } })
  }

  const handleSelect = (importFrom: string) => {
    dispatch({ type: 'users/IMPORT_USERS_REQUEST_MANUAL_INTENT', payload: { importFrom } })
  }

  return (
    <CometChatModal
      open={visible}
      onCancel={handleCancel}
      title="Import Users"
      description="Can you tell us where your user information is currently stored? Here are some options"
      headerDivider
      hideFooter
      size="sm"
    >
      <div className={style['cc-import-users-modal__options']}>
        {IMPORT_OPTIONS.map(option => (
          <CometChatButton
            key={option.value}
            hierarchy="secondary"
            className={style['cc-import-users-modal__option']}
            onClick={() => handleSelect(option.value)}
          >
            {option.label}
          </CometChatButton>
        ))}
      </div>
    </CometChatModal>
  )
}

export default ImportUsersModal
